<!-- display sub navigation -->
@if (!isJackpotsCategory() || !showV2JackpotModule) {
    <div
        id="category-filter"
        class="casino-game-tile-wrapper casino-lobby-width"
        *ngIf="(!isDefaultCategory && !hideCategoryTitleForTournaments) || jackpotTileCategory"
        [ngClass]="{
            'casino-touch-device': isTouch(),
            'casino-epcot-header': enableEpcotSubNavigation() || enablePillsSubNavigation(),
            'jackpot-tile-subnav': snapShotGroupId,
        }"
        [style.background-color]="subNavBackGroundColor">
        <div
            *ngIf="
                (displayHeader && (isMobileWidth() || selectedCategory?.gamelist?.length > 0)) ||
                (showLastLevelCategoryDropdown && prevLobbyCategories.length > 0) ||
                jackpotTileCategory ||
                (!isMobileWidth() && selectedCategory?.categoryname && selectedCategory?.gamesModel?.length > 0)
            ">
            <h2
                class="casino-sub-header-text game-tile-heading casino-lobby-header"
                [style.--NavBackBtnIconColor]="NavBackBtnIconColor"
                [style.--navBackground]="navBackground"
                [ngClass]="{
                    'casino-uk-header': !isMobileWidth() && isUkHeading,
                    'epcot-heading': enableEpcotSubNavigation(),
                    'sports-nav': navBackground,
                }">
                @if (showNavItem) {
                    @if (showPill()) {
                        <div
                            id="header-text"
                            class="pill-item"
                            [ngClass]="{
                                'casino-signposting-id': isSignPosting,
                                'active-sign-posting': isSignPostingCount,
                                'jackpot-epcot-pill': snapShotGroupId && !isMobileWidth(),
                            }"
                            (click)="subNavigationMenuInteraction($event)">
                            @if (isMobileWidth()) {
                                <button
                                    ds-button-icon
                                    size="medium"
                                    csAppearanceThemeModifier
                                    [elementType]="buttonType"
                                    [featureName]="featureName"
                                    [currentTheme]="currentTheme"
                                    (click)="goBack()">
                                    <span class="theme-close-small"></span>
                                </button>
                            } @else if (jackpotTileCategory) {
                                <span class="theme-close" (click)="goBack()"></span>
                            }
                            @if (isMobileWidth() || (!isMobileWidth() && !isUkHeading)) {
                                <a
                                    ds-pill
                                    csAppearanceThemeModifier
                                    [featureName]="featureName"
                                    [elementType]="navItemType"
                                    [currentTheme]="currentTheme"
                                    [selected]="true">
                                    <span
                                        slot="start"
                                        [class]="
                                            displayHeader && !jackpotTileCategory
                                                ? 'icn ' + (selectedCategory?.sitecoreData.attributes.icon || '')
                                                : ''
                                        ">
                                    </span>
                                    @if (displayHeader) {
                                        {{ displayTitle }}
                                    }
                                    <span slot="end">
                                        @if (isSignPosting) {
                                            <cc-sign-posting
                                                [category]="selectedCategory"
                                                [isDisplayBadge]="false"
                                                (signPostingCountValue)="signPostingCountHandler($event)">
                                            </cc-sign-posting>
                                        }
                                    </span>
                                    @if (prevLobbyCategories.length > 0) {
                                        <span class="icon theme-down"></span>
                                    }
                                </a>
                            }

                            @if ((!isMobileWidth() && isUkHeading && !isDiscoverCategory) || jackpotTileCategory) {
                                <cc-categoryicon-subtitle
                                    [title]="title"
                                    [displayHeading]="displayHeader || jackpotTileCategory"
                                    [subCategory]="selectedCategory"
                                    [recentAndGyml]="'NotRecentAndGyml'"
                                    [alignIconRight]="alignIconRight"
                                    [snapShotGroupId]="jackpotTileCategory"
                                    [lobbyType]="lobbyType"></cc-categoryicon-subtitle>
                            }
                        </div>
                    } @else {
                        <div
                            id="header-text"
                            [ngClass]="{
                                'casino-signposting-id': isSignPosting,
                                'active-sign-posting': isSignPostingCount,
                                'jackpot-pill': snapShotGroupId && isJackpotLandscape && !navBackground,
                            }"
                            (click)="subNavigationMenuInteraction($event)">
                            <span>
                                <span
                                    *ngIf="displayHeader && (isMobileWidth() || (!isMobileWidth() && !isUkHeading))"
                                    [ngStyle]="{
                                        'font-size': subCategoryTitleFontSize,
                                        'color': subCategoryTextColor,
                                        'font-family': lobbyTileFontFamily,
                                    }"
                                    >{{ displayTitle }}
                                    <cc-sign-posting
                                        *ngIf="isSignPosting"
                                        [category]="selectedCategory"
                                        [isDisplayBadge]="false"
                                        (signPostingCountValue)="signPostingCountHandler($event)">
                                    </cc-sign-posting>
                                </span>
                            </span>
                            <span class="theme-left" *ngIf="jackpotTileCategory && isJackpotLandscape && !navBackground" (click)="goBack()"></span>
                            <cc-categoryicon-subtitle
                                *ngIf="(!isMobileWidth() && isUkHeading && !isDiscoverCategory) || (!isMobileWidth() && jackpotTileCategory)"
                                [title]="title"
                                [displayHeading]="displayHeader || jackpotTileCategory"
                                [subCategory]="selectedCategory"
                                [recentAndGyml]="'NotRecentAndGyml'"
                                [alignIconRight]="alignIconRight"
                                [snapShotGroupId]="jackpotTileCategory"
                                [lobbyType]="lobbyType"></cc-categoryicon-subtitle>
                            <span class="icon theme-down" *ngIf="prevLobbyCategories.length > 0"></span>
                        </div>
                    }
                }

                <ul id="category-drop" *ngIf="showLastLevelCategoryDropdown && prevLobbyCategories.length > 0">
                    <li
                        class="category-drop-li"
                        *ngFor="let subCategory of prevLobbyCategories; let i = index"
                        [value]="i"
                        [ngClass]="{
                            'active-li-subnav':
                                subCategory.categoryid === selectedCategory?.categoryid || subCategory.dropdownhref === selectedCategory?.categoryid,
                        }"
                        (click)="categoryType = subCategory.categoryid; categoryTracking(subCategory.categoryid)">
                        <a style="display: block" [routerLink]="[categoryRelativeUrlTemplate, subCategory.dropdownhref]">
                            <span
                                [ngClass]="{
                                    'active-subnav':
                                        subCategory.categoryid === selectedCategory?.categoryid ||
                                        subCategory.dropdownhref === selectedCategory?.categoryid,
                                }"></span>
                            <span class="border-line"></span>
                            {{ subCategory.categoryname }}
                        </a>
                    </li>
                </ul>
                <span
                    class="theme-left sports-theme-left casino-mobile-navigation"
                    *ngIf="!enableEpcotSubNavigation() && !enablePillsSubNavigation() && navBackground"
                    [style.--navBackground]="navBackground"
                    (click)="goBack()"></span>
                <span
                    class="theme-left casino-mobile-navigation"
                    *ngIf="!enableEpcotSubNavigation() && !enablePillsSubNavigation() && !navBackground"
                    (click)="goBack()"></span>
                <div class="coinarcade-subtitle-text" *ngIf="arcadeLobbyGameConfig == currentLobbyType && showCoinExpiryText && ShowArcadeCoinExpiry">
                    <div class="coin-arcade-titletext" [textContent]="arcadeLobbyMessages?.CoinExpiryText1"></div>
                    <div class="coin-arcade-subtitletext">
                        <span
                            class="arcade-expiry-text"
                            [textContent]="arcadeCoinExpiry ? arcadeLobbyMessages?.CoinExpiryText2 : arcadeLobbyMessages?.coinExpiryToday"></span>
                        <span class="arcade-expiry">{{
                            arcadeCoinExpiry ? arcadeCoinExpiry + ' ' + arcadeLobbyMessages?.Days : arcadeLobbyMessages?.Today
                        }}</span>
                    </div>
                </div>
            </h2>
        </div>
    </div>
}
